import DatasetFieldPresenter from 'presenters/DatasetFieldPresenter';

const searchFields = (fields, value) =>
  fields.filter((field) => DatasetFieldPresenter.displayName(field).toLowerCase().includes(value.toLowerCase()));

export { searchFields };
